import {
  RedoFilterDropdownAnchor,
  RedoFilterGroup,
  RedoFilterSection,
} from "@redotech/arbiter/filter-group/redo-filter-group";
import { Translate, useTranslation } from "@redotech/redo-i18n";
import { ExistsFilterOperator } from "@redotech/redo-views-common/advanced-filters/exists-filter";
import { memo } from "react";
import { SimpleFilterDropdown } from "../../filters/simple-filter-dropdown";
import { ExistsTableFilter } from "../advanced-filter";

export const ExistsFilterGroup = memo(function ExistsFilterGroup({
  filter,
  setFilter,
  removeFilter,
}: {
  filter: ExistsTableFilter;
  setFilter(filter: ExistsTableFilter): void;
  removeFilter(): void;
  openOnRender: boolean;
}) {
  const { t } = useTranslation();
  const { value, operator } = filter.data;
  const conditionHolds =
    value == null
      ? true
      : operator === ExistsFilterOperator.NOT_EXISTS
        ? !value
        : value;
  const displayedOperator = conditionHolds
    ? ExistsFilterOperator.EXISTS
    : ExistsFilterOperator.NOT_EXISTS;
  const valueText = filter.boolDisplay
    ? filter.boolDisplay.trueDisplay
    : t("true", { context: "boolean filter value" });
  const setOperator = (next: ExistsFilterOperator) => {
    setFilter({
      ...filter,
      data: { ...filter.data, value: true, operator: next },
    });
  };

  return (
    <RedoFilterGroup
      Icon={filter.Icon}
      propertyName={filter.label ? filter.label : filter.displayName}
      query={
        <SimpleFilterDropdown
          filterStyle="query"
          options={filter.operators || Object.values(ExistsFilterOperator)}
          optionToFriendlyName={(option) => getExistsOperatorLabel(t, option)}
          setValue={setOperator}
          toggle
          value={displayedOperator}
        />
      }
      removeFilter={removeFilter}
      value={
        value == null ? (
          <RedoFilterDropdownAnchor
            color="primary"
            onClick={() => setOperator(displayedOperator)}
            text="..."
            weight="medium"
          />
        ) : (
          <RedoFilterSection text={valueText} weight="medium" />
        )
      }
    />
  );
});

function getExistsOperatorLabel(
  t: Translate,
  operator: ExistsFilterOperator,
): string {
  switch (operator) {
    case ExistsFilterOperator.EXISTS:
      return t("is", { context: "filter operator" });
    case ExistsFilterOperator.NOT_EXISTS:
      return t("is not", { context: "filter operator" });
  }
}
